import { requestApiUser } from "../functions";

export default {
    getOverallStats: async (days = 30) => {
        const res = await requestApiUser(
            `/analytics/stats?days=${days}`,
            "GET"
        );
        return res;
    },

    getRevenueByPeriod: async (period = 'month', limit = 12) => {
        const res = await requestApiUser(
            `/analytics/revenue?period=${period}&limit=${limit}`,
            "GET"
        );
        return res;
    },

    getPaymentsByDay: async (days = 7) => {
        const res = await requestApiUser(
            `/analytics/payments-by-day?days=${days}`,
            "GET"
        );
        return res;
    },

    getPaymentMethodsDistribution: async (days = 30) => {
        const res = await requestApiUser(
            `/analytics/payment-methods?days=${days}`,
            "GET"
        );
        return res;
    },

    getAmountDistribution: async (days = 30) => {
        const res = await requestApiUser(
            `/analytics/amount-distribution?days=${days}`,
            "GET"
        );
        return res;
    },

    getRevenueByHour: async (days = 30) => {
        const res = await requestApiUser(
            `/analytics/revenue-by-hour?days=${days}`,
            "GET"
        );
        return res;
    },

    getPeriodComparison: async (days = 30) => {
        const res = await requestApiUser(
            `/analytics/period-comparison?days=${days}`,
            "GET"
        );
        return res;
    },

    getOverviewStats: async () => {
        const res = await requestApiUser(
            `/analytics/overview`,
            "GET"
        );
        return res;
    }
};

